import Spinner from 'react-bootstrap/Spinner';
import "./Loader.css"
function Loader() {
  return <Spinner animation="border" variant="primary" style={{ textAlign: "center" }} />;
}

export default Loader;